import React from 'react';
const SYMBOL_URL = 'https://cdn.magicpatterns.com/uploads/tFWd9rvyYuc59xuWi6Xnp3/Beelyv_Simbolo_Dourado_4K_Transparente.png';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/s4KR2GWBrUMNCgYBDzW6NN/Beelyv_Logo_4K_Transparente.png';

/** Isolated gold symbol. Minimum 24px per the brand manual. */
export function BrandMark({
  size = 28,
  className = ''
}: {
  size?: number;
  className?: string;
}) {
  return <img src={SYMBOL_URL} alt="" aria-hidden="true" width={size} height={size} className={className} style={{
    width: size,
    height: size,
    objectFit: 'contain'
  }} data-id="element-605" data-mp="1m6omp273sdbj" />;
}
export type BrandIconVariant = 'primary' | 'light' | 'dark' | 'outline' | 'small';
const appIconSurface: Record<BrandIconVariant, string> = {
  /** Principal — gold symbol on Deep Green. */
  primary: 'bg-deep',
  /** Claro — gold symbol on cream. */
  light: 'bg-sand border border-sand-line',
  /** Escuro — gold symbol on the deepest green. */
  dark: 'bg-deeper',
  /** Outline — cream surface, thin gold keyline. Final outline artwork comes from the brand files. */
  outline: 'bg-sand border border-gold/60',
  /** Small / favicon — Deep Green, tighter padding for 16–32px. */
  small: 'bg-deep'
};

/**
 * Approved app-icon uses of the BEELYV symbol (brand board, "Ícones do app").
 * The symbol itself is never redrawn — only its surface changes.
 */
export function BrandAppIcon({
  variant = 'primary',
  size = 56,
  className = ''
}: {
  variant?: BrandIconVariant;
  size?: number;
  className?: string;
}) {
  const inset = variant === 'small' ? 0.78 : 0.6;
  return <span className={`grid shrink-0 place-items-center ${appIconSurface[variant]} ${className}`} style={{
    width: size,
    height: size,
    borderRadius: size * 0.24
  }} data-id="element-606" data-mp="b7tlna3rqxl3">
      <BrandMark size={Math.max(12, Math.round(size * inset))} data-id="element-607" data-mp="25k9qq7ktw5od" />
    </span>;
}

/** Full lockup. Minimum 120px per the brand manual. */
export function BrandLogo({
  width = 120,
  className = ''
}: {
  width?: number;
  className?: string;
}) {
  return <img src={LOGO_URL} alt="Beelyv" width={width} className={className} style={{
    width
  }} data-id="element-608" data-mp="29046u8gdxri1" />;
}